
import { useState, useEffect } from 'react';
import useGeolocation from '../../../useGeolocation';
import LocationTransparencyPopUp from './TransparencyModal';

export default function LocationService() {
  const { location, getUserLocation, permissionStatus } = useGeolocation();
  const [showCustomModal, setShowCustomModal] = useState(false);

  useEffect(() => {
    if (permissionStatus === 'prompt' && !localStorage.getItem('locationTransparencyAccepted')) {
      setShowCustomModal(true);
    } else if (permissionStatus === 'granted') {
      getUserLocation();
    }
  }, [permissionStatus, getUserLocation]);  //Use this useEffect block when we want to show the transparency modal and remove the one below

  // useEffect(() => {
  //   if (permissionStatus === 'prompt' || permissionStatus === 'granted') {
  //     getUserLocation();
  //   }
  // }, [permissionStatus, getUserLocation]);

  const handleAccept = () => {
    // localStorage.setItem('locationTransparencyAccepted', 'true');
    setShowCustomModal(false);
    getUserLocation();
  };

  const handleClose = () => {
    setShowCustomModal(false);
    console.log('User declined location access at custom popup.');
  };

  return (
    <>
      {showCustomModal && (
        <LocationTransparencyPopUp
          open={showCustomModal}
          onAccept={handleAccept}
          onClose={handleClose}
        />
      )}
    </>
  );
}
